import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { injectStripe } from 'react-stripe-elements'
import ReactPixel from 'react-facebook-pixel'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import formValidators from '../../../../utils/validation/formValidators'
import selectors from '../../../../store/shared/selectors'
import * as insTokenDuck from '../insTokenDuck'

/**
 * @class ValidateInsTokenForm
 */
class ValidateInsTokenForm extends Component {
  /**
   * @static propTypes
   * @type {{invalid, pristine, handleSubmit}}
   */
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isPerformingInsTokenRequest: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
  }

  render() {
    const {
      handleSubmit,
      invalid,
      isPerformingInsTokenRequest,
      pristine,
    } = this.props

    return (
      <form className="max-600">
        <div style={{height: 110}}>
          <Field
            component={renderTextInputWithFeedback}
            name="insToken"
            placeholder="Institutional Token"
          />
        </div>
        <button
          className="btn btn-lg btn-success btn-block"
          disabled={invalid || pristine || isPerformingInsTokenRequest}
          onClick={handleSubmit}
          style={{ marginTop: 5 }}
        >
          Verify Token
        </button>
      </form>
    )
  }
}

const validate = values => {
  const errors = {}
  errors.insToken = formValidators.isRequired(values.insToken)
  return errors
}

const wrappedWithForm = reduxForm({
  form: 'validateInsTokenForm',
  onSubmit: async (values, _dispatch, props) => {
    ReactPixel.trackCustom('verify_token_click')

    try {

      await props.performValidateInsToken(values)

    } catch (error) {
      throw new SubmissionError({ insToken:  error.message })
    }
  },
  validate,
})(ValidateInsTokenForm)


const makeMapStateToProps = () => {
  const isPerformingRequest = selectors.makeGetIsPerformingRequest()
  return state => ({
    insToken: insTokenDuck.getValidatedInsToken(state),
    isPerformingInsTokenRequest: isPerformingRequest(state, 'insToken'),
  })
}


const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performValidateInsToken: insTokenDuck.performValidateInsToken,
    },
    dispatch,
  )

export default injectStripe(
  connect(makeMapStateToProps, mapDispatchToProps)(wrappedWithForm),
)



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Onboarding/components/ValidateInsTokenForm.js